export default __webpack_public_path__ + "static/media/LTC-BNB.95fdd0f6.svg";